/* eslint-disable eqeqeq */
import { switcher, toID } from '../utils';
import { ACTIONS } from '../../const';
import env from '../../env';

import R from 'ramda';

const { TARGET } = env;

const tagSet = (tags = []) => tags.filter(t => t != '');

const convertFromServer = data => ({
    ...data,
    tags: tagSet(data.tags),
    section_id: TARGET == 'mlx' ? null : toID(data.section),
});

export default switcher(
    { origin: '' },
    {
        [ACTIONS.ADD_CONTENT](state, action) {
            let manifest = convertFromServer(action.manifest);

            return {
                ...state,
                [manifest.id]: manifest,
            };
        },
        [ACTIONS.DELETE_CONTENT](state, action) {
            const { content } = action.payload;

            return R.dissoc(String(content.id), state);
        },
        [ACTIONS.DELETE_COLLECTION](state, action) {
            const { section_id, name } = action.payload;

            const removeTagFromList = R.filter(t => t != name);

            const removeTagFromContent = R.over(
                R.lensProp('tags'),
                removeTagFromList
            );

            const updatecontent = content => {
                if (content.section_id == section_id) {
                    return removeTagFromContent(content);
                }
                return content;
            };

            return R.map(updatecontent, state);
        },
        [ACTIONS.ADD_CONTENT_TO_COLLECTION](state, action) {
            const { content_id, name } = action.payload;

            const lens = R.lensPath([content_id, 'tags']);
            const updateTag = R.append(name);

            return R.over(lens, updateTag, state);
        },
        [ACTIONS.REMOVE_CONTENT_FROM_COLLECTION](state, action) {
            const { content_id, name } = action.payload;

            const lens = R.lensPath([content_id, 'tags']);
            const updateTag = R.filter(t => t != name);

            return R.over(lens, updateTag, state);
        },
        [ACTIONS.SET_ORIGIN](
            state,
            { payload = window.location.hash.substr(1) }
        ) {
            return { ...state, origin: payload };
        },
    }
);



// WEBPACK FOOTER //
// ./src/reducers/content/content.js